<template>
  <div class="Affiche">            
    <a-scene
      landing-page
      xrextras-loading
      xrextras-runtime-error
      renderer="colorManagement: true;"
      xrweb="disableWorldTracking: true">
      <!-- 
      <a-assets>
        <img id="logo" src="https://romeosgin-vitrine.dpt.media/static/scan.png" crossorigin="anonymous">
        <a-asset-item :id="glb" :src="'https://romeosgin-vitrine.dpt.media/static/'+ glb +'.glb'"></a-asset-item>
      </a-assets> 
      -->
      <a-assets>
        <!--  
        <a-asset-item id="hole" src="https://romeosgin-vitrine.dpt.media/static/single.glb" crossorigin="anonymous"></a-asset-item>
        <a-asset-item id="hand" src="https://romeosgin-vitrine.dpt.media/static/romeo.glb" crossorigin="anonymous"></a-asset-item> 
        -->
        <a-asset-item 
          id="hand" 
          src="https://romeosgin-vitrine.dpt.media/static/affiche_big.glb" 
          crossorigin="anonymous"></a-asset-item>
        <a-asset-item 
          id="background" 
          src="https://romeosgin-vitrine.dpt.media/static/background.glb" 
          crossorigin="anonymous"></a-asset-item>
      </a-assets>

      <a-camera position="0 1 1"></a-camera>
      
      <!--  
      <a-light type="directional" intensity="1.5" position="0 1 0"></a-light>
      <a-light type="ambient" intensity="0.25"></a-light> 
      -->

      <a-entity image-target="name: affiche" visible="false" v-if="target == null || target == 'affiche'">
        <a-plane height="2" width="7" position=".25 1.515 0" xrextras-hider-material></a-plane>
        <a-plane height="2" width="7" position="-.25 1.515 0" xrextras-hider-material></a-plane>
        <a-plane height="2" width="7" position=".25 -1.515 0" xrextras-hider-material></a-plane>
        <a-plane height="2" width="7" position="-.25 -1.515 0" xrextras-hider-material></a-plane>
        <a-plane height="2" width="2" position="1.38 0 0" xrextras-hider-material></a-plane>
        <a-plane height="2" width="2" position="-1.38 0 0" xrextras-hider-material></a-plane>
        <a-entity
          position="0 0 -.5"
          scale=".5 .5 .5"
          cube-env-map = "path: https://romeosgin-vitrine.dpt.media/static/cube-env/; extension: png; reflectivity: .9;"
          shadow="receive: false"
          gltf-model="https://romeosgin-vitrine.dpt.media/static/background.glb">
        </a-entity>
        <a-entity
          position="0 -.25 -.25"
          gltf-model="https://romeosgin-vitrine.dpt.media/static/affiche_big.glb"
          cube-env-map = "path: https://romeosgin-vitrine.dpt.media/static/cube-env/; extension: png; reflectivity: .9;"
          shadow="receive: false"
          animation-mixer="clip: Animation; loop: repeat">
        </a-entity>  
      </a-entity>   
        
      <a-entity image-target="name: poster" visible="false" v-if="target == null || target == 'poster'">
        <a-plane height="2" width="7" position=".25 1.545 0" xrextras-hider-material></a-plane>
        <a-plane height="2" width="7" position="-.25 1.545 0" xrextras-hider-material></a-plane>
        <a-plane height="2" width="7" position=".25 -1.545 0" xrextras-hider-material></a-plane>
        <a-plane height="2" width="7" position="-.25 -1.545 0" xrextras-hider-material></a-plane>
        <a-plane height="2" width="2" position="1.38 0 0" xrextras-hider-material></a-plane>
        <a-plane height="2" width="2" position="-1.38 0 0" xrextras-hider-material></a-plane>
        <a-entity
          position="0 0 -.5"
          scale=".5 .5 .5"
          cube-env-map = "path: https://romeosgin-vitrine.dpt.media/static/cube-env/; extension: png; reflectivity: .9;"
          shadow="receive: false"
          gltf-model="https://romeosgin-vitrine.dpt.media/static/background.glb">
        </a-entity>
        <a-entity
          position="0 -.25 -.25"
          gltf-model="https://romeosgin-vitrine.dpt.media/static/affiche_big.glb"
          cube-env-map = "path: https://romeosgin-vitrine.dpt.media/static/cube-env/; extension: png; reflectivity: .9;"
          shadow="receive: false"
          animation-mixer="clip: Animation; loop: repeat">
        </a-entity>  
      </a-entity> 
     
      <!--    
      <xrextras-named-image-target name="affiche">
        <a-plane height="1" width="1" position=".25 1 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position="-.25 1 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position=".25 -1 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position="-.25 -1 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position=".85 0 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position="-.85 0 0" xrextras-hider-material></a-plane>    
        <xrextras-curved-target-container color="transparent" beans-spawn></xrextras-curved-target-container>
      </xrextras-named-image-target> 
      -->
      <!--  
      <xrextras-named-image-target name="poster">
        <a-plane height="1" width="1" position=".25 1 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position="-.25 1 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position=".25 -1 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position="-.25 -1 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position=".85 0 0" xrextras-hider-material></a-plane>
        <a-plane height="1" width="1" position="-.85 0 0" xrextras-hider-material></a-plane>    
        <xrextras-curved-target-container color="transparent" beans-spawn></xrextras-curved-target-container>
      </xrextras-named-image-target> 
      -->
    </a-scene> 
   
    <div class="Affiche__layers" :class="{ 'active': object_is_ready }">
 
      <div class="Affiche__scan" v-if="welcome"> 
        <div class="Affiche__witness">
          <img :src="require('@/commons/img/witness-small.png')"/>
        </div>
        <div class="Affiche__description">
          <div v-if="lang == 'en'">SCAN THE <span class="green">POSTER</span></div>
          <div v-else>SCANNE LA <span class="green">V</span>ITRINE</div>
        </div> 
      </div> 
     
      <div class="Affiche__layers-presentation" v-if="presentation">      
        <div class="Affiche__layers-logo padding">
          <img :src="require('@/commons/img/logo.png')"/>
        </div>
        <div class="Affiche__layers-plus">
          <img :src="require('@/commons/img/plus.png')"/>
        </div>
        <div class="Affiche__layers-fvckrender">
          <img :src="require('@/commons/img/fvckrender.png')"/>
        </div>
        <div class="Affiche__layers-presente">
          <span v-if="lang == 'en'">present</span>
          <span v-else>présentent</span>
        </div>
      </div>

      <div class="Affiche__layers-sequence" v-if="sequence">      
        <div>SÉQUENCE</br>AR</div>
        <div class="Affiche__simulation">Simulation durée</br>10 sec</div>
      </div>
      <div class="Affiche__layers-buttons" v-if="buttons">   

        <div class="Affiche__layers-logo">
          <img :src="require('@/commons/img/logo.png')"/>
        </div>

        <div class="Affiche__layers-plus">
          <img :src="require('@/commons/img/plus.png')"/>
        </div>

        <div class="Affiche__layers-fvckrender padding-bottom">
          <img :src="require('@/commons/img/fvckrender.png')"/>
        </div>

        <div class="Affiche__layers-button" @click="onClick('discover')">
          <img v-if="lang == 'en'" :src="require('@/commons/img/button-discover.png')"/>
          <img v-else :src="require('@/commons/img/button-decouvrir.png')"/>
        </div>

         <div class="Affiche__layers-button" @click="onClick('buy')">
          <img v-if="lang == 'en'" :src="require('@/commons/img/button-buy.png')"/>
          <img v-else :src="require('@/commons/img/button-acheter.png')"/>
        </div>

        <div class="Affiche__layers-button" @click="onClick('fvckrender')">
          <img :src="require('@/commons/img/button-fvckrender.png')"/>
        </div>

        <div class="Affiche__layers-button" @click="onClick('rg')">
          <img :src="require('@/commons/img/button-rg.png')"/>
        </div>
        
      </div>

    </div>
    
  </div>
</template>

<script>

import gsap from "gsap"

export default {

    name: 'Affiche',

    data: ()=>({
        target: null,
        welcome: false,
        presentation: false,
        sequence: false,
        buttons: false,
        scan_removed: false,
        presentation_completed: false,
        welcome_completed: false,
        use_sequence: false,
        object_is_ready: false,
        model: null,
        gbl: null,
        is_bc: false
    }),

    beforeCreate() {

      AFRAME.registerComponent('image-target', {

        schema: {
          name: {type: 'string'},
        },

        xrimagescanningCompleted: ()=> {
          this.addWelcome()     
        },

        xrimagefoundCompleted: (dt_name , name, object3D)=> {
          
          if(dt_name == name && this.target == null) {
            this.target = name
          }

          if(this.scan_removed == false){
            this.scan_removed = true
            this.removeScan()
          }

          // window.alert(object3D)

          if(this.welcome_completed == true)
            object3D.visible = true

        },

        init() {

          const { object3D } = this.el
          const { name } = this.data
          object3D.visible = false

          const showImage = ({ detail }) => {
            this.xrimagefoundCompleted(detail.name, this.data.name, object3D)
            if (name !== detail.name) {
              return
            }

            object3D.position.copy(detail.position)
            object3D.quaternion.copy(detail.rotation)
            object3D.scale.set(detail.scale, detail.scale, detail.scale)

            // if(this.presentation_completed == true)
            //   object3D.visible = true
          }

          const imageFound = (e) => { 
            showImage(e) 
          }
          const imageLost = (e) => { object3D.visible = false }
          const xrimagescanning = (e)=> { 
            this.xrimagescanningCompleted()
          }
          this.el.sceneEl.addEventListener('xrimagescanning', xrimagescanning)
          this.el.sceneEl.addEventListener('xrimagefound', imageFound)
          this.el.sceneEl.addEventListener('xrimageupdated', showImage)
          this.el.sceneEl.addEventListener('xrimagelost', imageLost)
        },
      })

      // AFRAME.registerComponent('beans-spawn', {

      //   xrimagescanningCompleted: ()=> {
      //     this.addWelcome()     
      //   },
      //   xrimagefoundCompleted: (scene, detail)=> {
      //     this.updateDetail(detail)
      //     if(this.scan_removed == false){
      //       this.scan_removed = true
      //       this.addObject3D(scene, detail)
      //       this.removeScan()
      //     }
      //   },
      //   xrimageupdatedCompleted: (scene, detail)=> {
      //     if(this.object_is_ready == true) 
      //       this.updateObject3D(detail) 
      //   },

      //   init() {
      //     const { object3D } = this.el
      //     const xrimagescanning = ({ detail })=> this.xrimagescanningCompleted()
      //     const xrimagefound = ({ detail })=> this.xrimagefoundCompleted(this.el.sceneEl, detail)
      //     const xrimageupdated = ({ detail })=> this.xrimageupdatedCompleted(this.el.sceneEl, detail)
      //     this.el.sceneEl.addEventListener('xrimagescanning', xrimagescanning)
      //     this.el.sceneEl.addEventListener('xrimagefound',  xrimagefound)
      //     this.el.sceneEl.addEventListener('xrimageupdated', xrimageupdated)
      //   },   
      // })

    },

    created() {
      this.glb = 'advance'
    },

    mounted() {
      this.checkIP()
    },

    methods: {

      checkIP() {
        const getIP = 'https://api.ipify.org?format=json' 
        this.axios({
          method: 'get',
          url: getIP,  
        })
        .then((res)=> {
          console.log('ONE');  
          console.log(res);
          this.ip = res.data.ip
          this.axios({
            method: 'get',
            url: 'https://ipapi.co/'+ this.ip +'/json/',  
          })
          .then((res)=> {
            console.log('TWO');
            console.log(res.data.region_code)
            this.is_bc = res.data.region_code == 'BC' ? true : false
          })
        }) 
      },

      onClick(arg) {
        const uri = {
          discover : "https://romeosgin.com/romeos-gin-v/",
          buy: "https://www.saq.com/fr/14824001",
          fvckrender: " https://www.instagram.com/fvckrender/?hl=en",
          rg: "https://romeosgin.com/fr/"
        }
        window.open(uri[arg], '_blank');
      },

      addWelcome() {
        if(this.welcome == true) return
        this.welcome = true
        this.$nextTick(()=>{  
          gsap.from(['.Affiche__witness', '.Affiche__description'], 
            {   
              duration: .35,
              scale: .25, 
              ease: "back.out", 
              alpha: 0, 
              delay: 1.5,
              stagger: .25
            })
        })
      },

      temporisation() {
        gsap.delayedCall(.15, ()=> { 
          this.welcome = false 
          this.welcome_completed = true
        })
        gsap.delayedCall(1.5, ()=>{ 
          this.presentation = true
          this.$nextTick(()=>{ this.showPresentation() })  
        })
      },

      updateDetail(detail) {
        this.$detail = detail
      },

      removeScan() {
        gsap.to('.Affiche__scan', { 
          opacity: 0,
          duration: .25,
          onComplete: ()=>{ this.temporisation() } 
        })
      },

      showPresentation() {
        gsap.from(['.Affiche__layers-logo', '.Affiche__layers-plus', '.Affiche__layers-fvckrender', '.Affiche__layers-presente'], 
            {   
              y: 100, 
              ease: "cubic.out", 
              alpha: 0, 
              delay: .2,
              stagger: .15,
              onComplete: ()=>{
                gsap.delayedCall(2, ()=>{ this.hidePresentation() })
              } 
            })
      },

      hidePresentation() {
        gsap.to(['.Affiche__layers-logo', '.Affiche__layers-plus', '.Affiche__layers-fvckrender', '.Affiche__layers-presente'], 
            {   
              ease: "cubic.out", 
              alpha: 0, 
              delay: .2,
              stagger: { each: .15, from: 'end' },
              onComplete: ()=>{ 
                this.object_is_ready = true
                this.presentation_completed = true
                this.beforeShowButtons()
              }
            })
      },

      beforeShowButtons() {
        // this.temporisation()
        gsap.delayedCall(16, ()=>{ 
          this.buttons = true
          this.$nextTick(()=>{ this.showButtons() })  
        })
      },

      addObject3D(scene, detail) {
        const absPos = new THREE.Vector3().copy(this.$detail.position)
        setTimeout(() => {
          this.model = document.createElement('a-entity')
          this.model.setAttribute('visible', 'false')
          this.model.setAttribute('gltf-model', 'https://romeosgin-vitrine.dpt.media/static/'+ this.glb +'.glb')
          this.model.setAttribute('cube-env-map', { path: "https://romeosgin-vitrine.dpt.media/static/cube-env/", extension: 'png', reflectivity: .9 })
          this.model.setAttribute('shadow', { receive: false })
          this.model.setAttribute('animation-mixer', { 
            clip: 'Animation', 
            loop: 'once', 
            clampWhenFinished: true  
          })
          this.model.object3D.position.copy(detail.position)
          this.model.object3D.quaternion.copy(detail.rotation)
          this.model.object3D.scale.set(detail.scale, detail.scale, detail.scale)
       
          scene.appendChild(this.model)

          this.model.addEventListener('model-loaded', ()=> {
            this.model.setAttribute('visible', 'true') 
            this.object_is_ready = true
            this.beforeShowButtons()
          })
        }, 250)
      },

      updateObject3D(detail) {

        this.model.object3D.position.copy(detail.position)
        this.model.object3D.quaternion.copy(detail.rotation)
        this.model.object3D.scale.set(detail.scale, detail.scale, detail.scale)
      },

      showSequence() {
        gsap.from(['.Affiche__layers-sequence'], 
            {   
              ease: "cubic.out", 
              alpha: 0, 
              delay: .2,
              stagger: .15
            })

        gsap.delayedCall(22, ()=>{ 
          this.sequence = false
          this.buttons = true
          this.$nextTick(()=>{ this.showButtons() })  
        })
      },

      showButtons() {
        gsap.from(['.Affiche__layers-logo', '.Affiche__layers-plus', '.Affiche__layers-fvckrender', '.Affiche__layers-button'], 
            {   
              y: 100, 
              ease: "cubic.out", 
              alpha: 0, 
              delay: .2,
              stagger: .15
            })
      }

    }

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Affiche
  overflow hidden
  position absolute
  width 100%
  height 100%
  color white
  // background #409171
  font-family gotham

  &__load
    position fixed
    opacity 0
    top -500
  
  &__V  
    // width 60%
    width 30vh

  
  &__scan 
    position absolute
    display flex 
    flex-direction column
    align-items center
    justify-content center
    width 100%
    height 100%
    transition opacity 1s 

    &-enter
    &-leave-active
      opacity 0

  &__description 
    font-size 22px 
    padding 24px
    position absolute

  &__layers 
    pointer-events none
    width 100% 
    height 100% 
    top 0px
    left 0px
    position fixed
    z-index 10000

    &.active 
      pointer-events auto

    &-animation 
    &-sequence
    &-buttons
      position absolute
      display flex 
      flex-direction column
      align-items center
      justify-content center
      width 100%
      height 100%

    &-sequence 
      font-size 48px
      text-align center
      color black

    &-bottom 
      width 100%
      height 98px

    &-gif
      // width 60%
      width 30vh

    &-presentation
      position absolute
      display flex 
      flex-direction column
      align-items center
      justify-content flex-start
      width 100%
      height 100%

    &-logo 
      // width 60%
      width 30vh

      &.padding
        padding-top 20%

    &-fvckrender
      // width 60%
      width 30vh
      padding-top 16px

      &.padding-bottom 
        // padding-bottom 16px
        padding-bottom 4vh

    &-plus 
      width 24px

    &-presente 
      padding-top 32px
      text-transform uppercase
      font-size 16px

    &-button
      // padding 12px 16px 0
      padding 2vh 4vh 0
      // width 50vh

  &__simulation 
    font-size 16px
    padding-top 32px
    color black

  &__video
    position absolute
    top 0
    left 0 
    opacity .6
    width 100%
    height 100%
    transition opacity 1s 

    &-enter
    &-leave-active
      opacity 0
    
    & video 
      width 100vw 
      object-fit fill

.green 
  color #64c39e

#requestingCameraPermissions 
  color black
  background-color black
  opacity 0
  position absolute 
  width 1000px

.poweredby-img
  opacity 0 !important
  display none

.button-primary-8w 
  background-color green
  color #fff

</style>














